import * as THREE from 'three';
import Sizes from './Sizes.js';
import Time from './Time.js';
import Camera from './Camera.js';
import Renderer from './Renderer.js';
import MouseController from '../interactions/MouseController.js';
import World from '../world/World.js';
import Effects from '../postprocessing/Effects.js';

let instance = null;

export default class Experience {
  constructor(canvas) {
    if (instance) {
      return instance;
    }
    instance = this;

    window.experience = this;

    this.canvas = canvas;
    this.isDark = false; // Light mode default as requested
    document.documentElement.setAttribute('data-theme', 'light');

    // 1. Setup core modules
    this.sizes = new Sizes();
    this.time = new Time();
    this.scene = new THREE.Scene();
    this.camera = new Camera(this);
    this.renderer = new Renderer(this);
    this.mouse = new MouseController(this);
    this.world = new World(this);
    this.effects = new Effects(this);

    // Initial theme setup on world, renderer and effects
    this.renderer.setTheme(this.isDark);
    this.world.setTheme(this.isDark);
    this.effects.setTheme(this.isDark);

    // 2. Event listeners
    this.sizes.on('resize', () => {
      this.resize();
    });

    this.time.on('tick', () => {
      this.update();
    });
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    document.documentElement.setAttribute('data-theme', this.isDark ? 'dark' : 'light');

    if (this.renderer) {
      this.renderer.setTheme(this.isDark);
    }
    if (this.world) {
      this.world.setTheme(this.isDark);
    }
    if (this.effects) {
      this.effects.setTheme(this.isDark);
    }

    return this.isDark;
  }

  resize() {
    this.camera.resize();
    this.renderer.resize();
    if (this.effects) {
      this.effects.resize();
    }
  }

  update() {
    this.mouse.update();
    this.camera.update();
    this.world.update(this.time.elapsed);

    if (this.effects && this.effects.enabled) {
      this.effects.update();
    } else {
      this.renderer.update();
    }
  }

  destroy() {
    this.sizes.callbacks = {};
    this.time.callbacks = {};
  }
}
